/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { IceTypes } from '../../models/icetypes';
import { IceEntity } from '../../models/core/IceEntity';

export class alertsummary extends IceEntity {
  glkey: string = "";
  gltype: IceTypes.guidelinetype.gdetypeDisease;
  alert_type: IceTypes.ALERTTYPE.alertDiseaseManagement;
  severity_type: IceTypes.severitytype.servTypeCritical;
  details: string = "";

  gettablename(): string {
    return "ALERT_SUMMARY";
  }
}

export class cpt_contraindication extends alertsummary { gettablename(): string { return "CPT_ContraIndication"; } }
export class cpt_interaction extends alertsummary { gettablename(): string { return "CPT_Interaction"; } }
export class cpt_synonym extends alertsummary { gettablename(): string { return "CPT_Synonym"; } }
export class cpt_required extends alertsummary { gettablename(): string { return "CPT_Required"; } }
export class cpt_addon extends alertsummary { gettablename(): string { return "CPT_AddOn"; } }
export class cpt_includes extends alertsummary { gettablename(): string { return "CPT_Includes"; } }
export class cpt_excludes1 extends alertsummary { gettablename(): string { return "CPT_Excludes1"; } }
export class cpt_excludes2 extends alertsummary { gettablename(): string { return "CPT_Excludes2"; } }
export class cpt_notallowed extends alertsummary { gettablename(): string { return "CPT_NotAllowed"; } }
export class cpt_allowed extends alertsummary { gettablename(): string { return "CPT_Allowed"; } }
export class cpt_notapplicable extends alertsummary { gettablename(): string { return "CPT_NotApplicable"; } }
export class cpt_muepolicy2 extends alertsummary { gettablename(): string { return "CPT_MUEPolicy2"; } }
export class cpt_mueclinical3 extends alertsummary { gettablename(): string { return "CPT_MUEClinical3"; } }
export class cpt_consider extends alertsummary { gettablename(): string { return "CPT_Consider"; } }

export class ndc_contraindication extends alertsummary { gettablename(): string { return "NDC_ContraIndication"; } }
export class ndc_interaction extends alertsummary { gettablename(): string { return "NDC_Interaction"; } }
export class ndc_synonym extends alertsummary { gettablename(): string { return "NDC_Synonym"; } }
export class ndc_required extends alertsummary { gettablename(): string { return "NDC_Required"; } }
export class ndc_addon extends alertsummary { gettablename() { return "NDC_AddOn"; } }
export class ndc_includes extends alertsummary { gettablename() { return "NDC_Includes"; } }
export class ndc_excludes1 extends alertsummary { gettablename() { return "NDC_Excludes1"; } }
export class ndc_excludes2 extends alertsummary { gettablename() { return "NDC_Excludes2"; } }
export class ndc_notallowed extends alertsummary { gettablename() { return "NDC_NotAllowed"; } }
export class ndc_allowed extends alertsummary { gettablename() { return "NDC_Allowed"; } }
export class ndc_notapplicable extends alertsummary { gettablename() { return "NDC_NotApplicable"; } }
export class ndc_muepolicy2 extends alertsummary { gettablename() { return "NDC_MUEPolicy2"; } }
export class ndc_mueclinical3 extends alertsummary { gettablename() { return "NDC_MUEClinical3"; } }
export class ndc_consider extends alertsummary { gettablename() { return "NDC_Consider"; } }

export class diag_contraindication extends alertsummary { gettablename(): string { return "Diag_ContraIndication"; } }
export class diag_interaction extends alertsummary { gettablename(): string { return "Diag_Interaction"; } }
export class diag_synonym extends alertsummary { gettablename(): string { return "Diag_Synonym"; } }
export class diag_required extends alertsummary { gettablename(): string { return "Diag_Required"; } }
export class diag_includes extends alertsummary { gettablename() { return "Diag_Includes"; } }
export class diag_excludes1 extends alertsummary { gettablename() { return "Diag_Excludes1"; } }
export class diag_excludes2 extends alertsummary { gettablename() { return "Diag_Excludes2"; } }
export class diag_consider extends alertsummary { gettablename() { return "Diag_Consider"; } }

export class allergy_interaction extends alertsummary { gettablename(): string { return "Allergy_Interaction"; } }

export class limitsummary extends alertsummary { gettablename(): string { return "LimitSummary"; } }
export class surveysummary extends alertsummary { gettablename(): string { return "SurveySummary"; } }

export class resultinformation extends alertsummary {
  reportkey: string = "";

  gettablename(): string  { return "RESULT_INFORMATION"; }
}

export class coderesult extends resultinformation {
  code: string = "";
  title: string = "";
  with_code: string = "";
  with_key: string = "";
  with_title: string = "";

  gettablename(): string { return "CodeResult"; }
}

export class limitandsurveyresult extends resultinformation {
  code: string = "";
  value: number = 0.0;
  typeofrange: IceTypes.TYPEOFRANGE.torInside;
  lower: number = 0.0;
  upper: number = 0.0;
  units: string = "";
  dateofvalue: any = NaN;
  description: string = "";

  gettablename(): string { return "LimitAndSurveyResult"; }

}

export class resultsummary extends IceEntity {
  srctype: IceTypes.SourceType.srcUndefined;
  srckey: string = "";

  DETAILS: resultinformation[] = [];

  gettablename(): string { return "Result"; }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "DETAILS") return true;

    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "DETAILS") return "RESULT_INFORMATION,CodeResult,LimitAndSurveyResult";

    return null;
  }
}

enum AlertSummaryType {
  Unknown = 0,
  CPT_ContraIndication = 101,
  CPT_Interaction = 102,
  CPT_Synonym = 103,
  CPT_Required = 104,
  CPT_AddOn = 105,
  CPT_Includes = 106,
  CPT_Excludes1 = 107,
  CPT_Excludes2 = 108,
  CPT_NotAllowed = 109,
  CPT_Allowed = 110,
  CPT_NotApplicable = 111,
  CPT_MUEPolicy2 = 112,
  CPT_MUEClinical3 = 113,
  CPT_Consider = 114,

  Diag_ContraIndication = 201,
  Diag_Interaction = 202,
  Diag_Synonym = 203,
  Diag_Required = 204,
  Diag_Includes = 205,
  Diag_Excludes1 = 206,
  Diag_Excludes2 = 207,
  Diag_Consider = 208,

  NDC_ContraIndication = 301,
  NDC_Interaction = 302,
  NDC_Synonym = 303,
  NDC_Required = 304,
  NDC_AddOn = 305,
  NDC_Includes = 306,
  NDC_Excludes1 = 307,
  NDC_Excludes2 = 308,
  NDC_NotAllowed = 309,
  NDC_Allowed = 310,
  NDC_NotApplicable = 311,
  NDC_MUEPolicy2 = 312,
  NDC_MUEClinical3 = 313,
  NDC_Consider = 314,

  Allergy_Interaction = 41,

  Limits = 51,

  Surveys = 61,

  Results = 71,
}

export class guidelinesummary extends IceEntity
{
  code: string = "";
  srctype: IceTypes.SourceType.srcUndefined;
  srckey: string = "";
  gltype: IceTypes.guidelinetype.gdetypeDisease;
  default_alerttype: IceTypes.ALERTTYPE.alertDiseaseManagement;

  ALERT_SUMMARIES: alertsummary[] = [];
  CPTContraIndications: cpt_contraindication[] = [];
  NDCContraIndications: ndc_contraindication[] = [];
  DiagContraIndications: diag_contraindication[] = [];

  CPTInteractions: cpt_interaction[] = [];
  NDCInteractions: ndc_interaction[] = [];
  DiagInteractions: diag_interaction[] = [];

  AllergyInteractions: allergy_interaction[] = [];

  CPTSynonyms: cpt_synonym[] = [];
  NDCSynonyms: ndc_synonym[] = [];
  DiagSynonyms: diag_synonym[] = [];

  CPTRequired: cpt_required[] = [];
  NDCRequired: ndc_required[] = [];
  DiagRequired: diag_required[] = [];

  CPTAddOn: cpt_addon[] = [];
  NDCAddOn: ndc_addon[] = [];

  CPTIncludes: cpt_includes[] = [];
  NDCIncludes: ndc_includes[] = [];
  DiagIncludes: diag_includes[] = [];

  CPTExcludes1: cpt_excludes1[] = [];
  NDCExcludes1: ndc_excludes1[] = [];
  DiagExcludes1: diag_excludes1[] = [];

  CPTExcludes2: cpt_excludes2[] = [];
  NDCExcludes2: ndc_excludes2[] = [];
  DiagExcludes2: diag_excludes2[] = [];

  CPTNotAllowed: cpt_notallowed[] = [];
  NDCNotAllowed: ndc_notallowed[] = [];

  CPTAllowed: cpt_allowed[] = [];
  NDCAllowed: ndc_allowed[] = [];

  CPTNotApplicable: cpt_notapplicable[] = [];
  NDCNotApplicable: ndc_notapplicable[] = [];

  CPTMUEPolicy2: cpt_muepolicy2[] = [];
  NDCMUEPolicy2: ndc_muepolicy2[] = [];

  CPTMUEClinical3: cpt_mueclinical3[] = [];
  NDCMUEClinical3: ndc_mueclinical3[] = [];

  CPTConsider: cpt_consider[] = [];
  NDCConsider: ndc_consider[] = [];
  DiagConsider: diag_consider[] = [];

  LimitSummaries: limitsummary[] = [];
  SurveySummaries: surveysummary[] = [];
  Results: resultsummary[] = [];
  
  gettablename(): string { return "GUIDELINE_SUMMARY"; }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ALERT_SUMMARIES") return true;
    else if (ColumnName == "CPTContraIndications") return true;
    else if (ColumnName == "CPTInteractions") return true;
    else if (ColumnName == "CPTSynonyms") return true;
    else if (ColumnName == "CPTRequired") return true;
    else if (ColumnName == "CPTAddOn") return true;
    else if (ColumnName == "CPTIncludes") return true;
    else if (ColumnName == "CPTExcludes1") return true;
    else if (ColumnName == "CPTExcludes2") return true;
    else if (ColumnName == "CPTNotAllowed") return true;
    else if (ColumnName == "CPTAllowed") return true;
    else if (ColumnName == "CPTNotApplicable") return true;
    else if (ColumnName == "CPTMUEPolicy2") return true;
    else if (ColumnName == "CPTMUEClinical3") return true;
    else if (ColumnName == "CPTConsider") return true;
    else if (ColumnName == "NDCContraIndications") return true;
    else if (ColumnName == "NDCInteractions") return true;
    else if (ColumnName == "NDCSynonyms") return true;
    else if (ColumnName == "NDCRequired") return true;
    else if (ColumnName == "NDCAddOn") return true;
    else if (ColumnName == "NDCIncludes") return true;
    else if (ColumnName == "NDCExcludes1") return true;
    else if (ColumnName == "NDCExcludes2") return true;
    else if (ColumnName == "NDCNotAllowed") return true;
    else if (ColumnName == "NDCAllowed") return true;
    else if (ColumnName == "NDCNotApplicable") return true;
    else if (ColumnName == "NDCMUEPolicy2") return true;
    else if (ColumnName == "NDCMUEClinical3") return true;
    else if (ColumnName == "NDCConsider") return true;
    else if (ColumnName == "DiagContraIndications") return true;
    else if (ColumnName == "DiagInteractions") return true;
    else if (ColumnName == "DiagSynonyms") return true;
    else if (ColumnName == "DiagRequired") return true;
    else if (ColumnName == "DiagIncludes") return true;
    else if (ColumnName == "DiagExcludes1") return true;
    else if (ColumnName == "DiagExcludes2") return true;
    else if (ColumnName == "DiagConsider") return true;
    else if (ColumnName == "AllergyInteractions") return true;
    else if (ColumnName == "LimitSummaries") return true;
    else if (ColumnName == "SurveySummaries") return true;
    else if (ColumnName == "Results") return true;

    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ALERT_SUMMARIES") return "ALERT_SUMMARY";
    else if (ColumnName == "CPTContraIndications") return "CPT_ContraIndication";
    else if (ColumnName == "CPTInteractions") return "CPT_Interaction";
    else if (ColumnName == "CPTSynonyms") return "CPT_Synonym";
    else if (ColumnName == "CPTRequired") return "CPT_Required";
    else if (ColumnName == "CPTAddOn") return "CPT_AddOn";
    else if (ColumnName == "CPTIncludes") return "CPT_Includes";
    else if (ColumnName == "CPTExcludes1") return "CPT_Excludes1";
    else if (ColumnName == "CPTExcludes2") return "CPT_Excludes2";
    else if (ColumnName == "CPTNotAllowed") return "CPT_NotAllowed";
    else if (ColumnName == "CPTAllowed") return "CPT_Allowed";
    else if (ColumnName == "CPTNotApplicable") return "CPT_NotApplicable";
    else if (ColumnName == "CPTMUEPolicy2") return "CPT_MUEPolicy2";
    else if (ColumnName == "CPTMUEClinical3") return "CPT_MUEClinical3";
    else if (ColumnName == "CPTConsider") return "CPT_Consider";
    else if (ColumnName == "NDCContraIndications") return "NDC_ContraIndication";
    else if (ColumnName == "NDCInteractions") return "NDC_Interaction";
    else if (ColumnName == "NDCSynonyms") return "NDC_Synonym";
    else if (ColumnName == "NDCRequired") return "NDC_Required";
    else if (ColumnName == "NDCAddOn") return "NDC_AddOn";
    else if (ColumnName == "NDCIncludes") return "NDC_Includes";
    else if (ColumnName == "NDCExcludes1") return "NDC_Excludes1";
    else if (ColumnName == "NDCExcludes2") return "NDC_Excludes2";
    else if (ColumnName == "NDCNotAllowed") return "NDC_NotAllowed";
    else if (ColumnName == "NDCAllowed") return "NDC_Allowed";
    else if (ColumnName == "NDCNotApplicable") return "NDC_NotApplicable";
    else if (ColumnName == "NDCMUEPolicy2") return "NDC_MUEPolicy2";
    else if (ColumnName == "NDCMUEClinical3") return "NDC_MUEClinical3";
    else if (ColumnName == "NDCConsider") return "NDC_Consider";
    else if (ColumnName == "DiagContraIndications") return "Diag_ContraIndication";
    else if (ColumnName == "DiagInteractions") return "Diag_Interaction";
    else if (ColumnName == "DiagSynonyms") return "Diag_Synonym";
    else if (ColumnName == "DiagRequired") return "Diag_Required";
    else if (ColumnName == "DiagIncludes") return "Diag_Includes";
    else if (ColumnName == "DiagExcludes1") return "Diag_Excludes1";
    else if (ColumnName == "DiagExcludes2") return "Diag_Excludes2";
    else if (ColumnName == "DiagConsider") return "Diag_Consider";
    else if (ColumnName == "AllergyInteractions") return "Allergy_Interaction";
    else if (ColumnName == "LimitSummaries") return "LimitSummary";
    else if (ColumnName == "SurveySummaries") return "SurveySummary";
    else if (ColumnName == "Results") return "Result";

    return null;
  }
}
